import React from 'react';
import Box from '@mui/material/Box';
import { Stack, Typography, Button } from '@mui/material';
import {
  ErrorBox, ErrorMessage, ErrorTitle,
} from '@marageti/z4-lib';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as NotFoundSVG } from '../../assets/svg/404@2x.svg';

const NotFound = () => {
  const navigate = useNavigate();
  const goBack = () => navigate(-1);
  const goHome = () => navigate('/');

  const { state } = useLocation();
  const error = state?.error;

  return (
    <Box
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        marginTop: error ? 32 : 144,
      }}
    >
      {error && (
        <ErrorBox>
          <ErrorTitle>
            There was an error.
          </ErrorTitle>
          <ErrorMessage>
            {error.code && `Code: ${error.code} `}
            {error.message}
          </ErrorMessage>
          <ErrorMessage>
            {error.id && `ID: ${error.id}`}
          </ErrorMessage>
        </ErrorBox>
      )}
      <NotFoundSVG
        style={{
          marginBottom: '26px',
        }}
      />
      <Typography variant="body1">Sorry, we couldn&apos;t find this page</Typography>
      <Typography variant="body1">
        Please
        <span style={{ fontWeight: 'bold', color: '#0D1718', cursor: 'pointer' }} onClick={goBack}>&nbsp;go back</span>
        &nbsp;or
        <Link style={{ fontWeight: 'bold', color: '#0D1718', textDecoration: 'none' }} to="/"> return home</Link>
      </Typography>
      <Stack
        spacing={1}
        style={{
          maxWidth: '342px', width: '100%', position: 'fixed', bottom: '1.5rem',
        }}
      >
        <Button variant="outlined" onClick={goBack}>
          Go Back
        </Button>
        <Button variant="contained" onClick={goHome}>
          Return Home
        </Button>
      </Stack>
    </Box>
  );
};

export default NotFound;
